// Maps the website's separate `tours` catalog onto the compta enduro product.
//
// WHY: compta maps all enduro tours under ONE activity (the "Electric Enduro
// Tours" activity) with variants half_day/full_day/2_day. The website `tours`
// table uses its own per-tour UUIDs that compta knows nothing about, so booking
// a Tour by tour.id never resolves → needs_review. We therefore book tours
// against the enduro ACTIVITY id + the duration variant instead.
//
// NB: the tours table's duration_days is unreliable (all rows = 1 in prod), so
// the variant is derived from the tour's slug/title, not duration_days.
import type { Tour } from '@/types'

// Enduro tours only ever have a duration variant (no sunrise/sunset).
export type EnduroTourVariant =
  | 'half_day'
  | 'full_day'
  | '2_day'
  | '6_day'
  | null

// The compta "Electric Enduro Tours" activity (products.source_id) that the
// half/full/2-day enduro tour products are mapped under.
export const ENDURO_ACTIVITY_ID = '85022749-92d9-4e58-b76f-efe2746f35e5'

// Derive the enduro duration variant from a tour's slug/title.
// Returns null when it can't be determined (booking then lands as needs_review,
// the honest fallback, rather than silently mapping to the wrong product).
export function enduroTourVariant(
  tour: Pick<Tour, 'slug' | 'title'>
): EnduroTourVariant {
  const s = `${tour.slug || ''} ${tour.title || ''}`.toLowerCase()
  // 6-Day Xaysomboun Enduro Camp (slug: xaysomboun-6-day-enduro-camp).
  // Match on "xaysomboun" (distinctive, slug-stable) or any 4/6-day digit pattern.
  // Checked first so it can't be mis-bucketed by the broader rules below.
  if (/\b(4|six|6|four)[\s-]?day/.test(s) || s.includes('xaysomboun'))
    return '6_day'
  if (/\b(2|two)[\s-]?day/.test(s)) return '2_day'
  if (s.includes('half')) return 'half_day'
  if (s.includes('full')) return 'full_day'
  return null
}
